import { useEffect, useContext } from 'react'

import MenuLinkBtn from "../UI/MenuLinkBtn/MenuLinkBtn";

import { AuthContext } from "../context/authContext";


const ControlPage = () => {
    const {currentUser} = useContext(AuthContext);
    useEffect(() => {document.title = "Управление"}, [])

   


    return(
        <> 
            <div className="container">
    <div className="admin__menu">
        <MenuLinkBtn link="/admin/test_permit"  text="Разрешение на тестирование"/>
        <MenuLinkBtn link="/admin/results"  text="Результаты"/>
        <MenuLinkBtn link="/admin/users"  text="Пользователи"/>
        <MenuLinkBtn link="/admin/tests-category"  text="Тесты"/>
        <MenuLinkBtn link="/admin/mas"  text="МАСЫ"/>
        <MenuLinkBtn link="/admin/pharmacies"  text="Аптеки"/>
        <MenuLinkBtn link="/admin/reports"  text="Отчеты"/>

        {currentUser.admin === 2 &&  <MenuLinkBtn link="/admin/settings"  text="Настройки"/>}
  
    </div>
</div>
        </>
    )
}


export default ControlPage